import React, { useState } from 'react';
import HROverview from './HROverview';
import HRLiveBoard from './HRLiveBoard';
import HREmployees from './HREmployees';
import HRLeaves from './HRLeaves';
import HRReports from './HRReports';
import HRLocations from './HRLocations';
import './HRDashboard.css';

const NAV_ITEMS = [
  { key: 'overview',  label: 'Overview',       icon: '📊' },
  { key: 'liveboard', label: 'Live Board',      icon: '⬤'  },
  { key: 'employees', label: 'Employees',       icon: '👤' },
  { key: 'leaves',    label: 'Leave Requests',  icon: '📋' },
  { key: 'reports',   label: 'Reports',         icon: '📈' },
  { key: 'locations', label: 'Locations',       icon: '📍' },
];

export default function HRDashboard({ employee, onLogout }) {
  const [activePage, setActivePage] = useState('overview');

  function renderPage() {
    switch (activePage) {
      case 'overview':  return <HROverview />;
      case 'liveboard': return <HRLiveBoard />;
      case 'employees': return <HREmployees />;
      case 'leaves':    return <HRLeaves />;
      case 'reports':   return <HRReports />;
      case 'locations': return <HRLocations />;
      default:          return <HROverview />;
    }
  }

  const initials = employee?.full_name
    ? employee.full_name.trim().split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase()
    : 'HR';

  return (
    <div className="hr-shell">
      <aside className="hr-sidebar">
        <div className="hr-sidebar-brand">
          <span className="hr-brand-logo">F</span>
          <div className="hr-brand-text">
            <span className="hr-brand-name">Fotile AMS</span>
            <span className="hr-brand-role">HR Dashboard</span>
          </div>
        </div>

        <nav className="hr-nav">
          {NAV_ITEMS.map(item => (
            <button
              key={item.key}
              className={`hr-nav-item ${activePage === item.key ? 'hr-nav-active' : ''}`}
              onClick={() => setActivePage(item.key)}
            >
              <span className="hr-nav-icon">{item.icon}</span>
              <span className="hr-nav-label">{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="hr-sidebar-footer">
          <div className="hr-user-info">
            <div className="hr-user-avatar">{initials}</div>
            <div className="hr-user-details">
              <span className="hr-user-name">{employee?.full_name || 'HR Admin'}</span>
              <span className="hr-user-badge">{employee?.role?.toUpperCase() || 'HR'}</span>
            </div>
          </div>
          <button className="hr-logout-btn" onClick={onLogout}>Sign out</button>
        </div>
      </aside>

      <main className="hr-main">
        {renderPage()}
      </main>
    </div>
  );
}